export default function FaqTabs({ faqs, activeSection, onTabClick }) {
    return (

            <div className="faq-tab-buttons">
                {faqs.map((item) => (
                    <button
                        key={item.title}
                        className={activeSection === item.title ? "active" : ""}
                        onClick={() => onTabClick(item.title)}
                        type="button"
                    >
                        {item.title}
                    </button>
                ))}
            </div>
  
    );
}
